//import Breadcrumb from "../components/Breadcrumb";  
"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const [theme, setTheme] = useState<"dark" | "light">("light");

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme === "dark" || storedTheme === "light") {
      setTheme(storedTheme);
    }
  }, []);

  const textColor =     
    theme === "dark" ? "text-white/90 " : "text-white/90 ";

  const activeColor =
    theme === "dark" ? "text-white/90 " : "text-white/90 ";

  return (
    <nav className="drop-shadow-lg">
      <ol className={`flex items-center gap-2 text-sm md:text-base font-semibold ${textColor}`}>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
           
            {index !== 0 && (
              <ChevronRight
                size={16}
                className="text-gray-400"
              />
            )}

            {item.href ? (
              <Link
                href={item.href}
                className={`hover:underline transition ${textColor}`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={activeColor}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

 